import { render, staticRenderFns } from "./publish-buttons.vue?vue&type=template&id=d7f73932"
import script from "./publish-buttons.vue?vue&type=script&lang=js"
export * from "./publish-buttons.vue?vue&type=script&lang=js"
import style0 from "./publish-buttons.vue?vue&type=style&index=0&id=d7f73932&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports